import Vue from "vue";

const themes = {
  namespaced: true,
  state: {
    theme: "default",
    themes: ["default", "defaultDark"],
  },
  mutations: {
    setTheme(state, payload) {
      if (state.themes.includes(payload)) {
        state.theme = payload;
        Vue.prototype.$material.theming.theme = payload;
      }
    },
  },
  actions: {},
  getters: {},
};

export default themes;
